$(document).ready(function () {
  $('.apl_lob_slider').on('init', function(event, slick) {
    const $initAplLobSlider = slick.$slider[0];

    // Timeout needed for slow loading
    setTimeout(() => {
      customSlickSlider();
      setInitialSlideVisibility($initAplLobSlider);
    }, 500);
  });
  $('.apl_lob_slider').slick({
    slidesToShow: 4.5,
    slidesToScroll: 2,
    infinite: false,
    prevArrow: $('.nav-left-arrow'),
    nextArrow: $('.nav-right-arrow'),
    variableWidth: true,
    speed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: false,
          variableWidth: true,
          speed: 1000,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
          speed: 1000,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: true,
          speed: 500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: true,
          speed: 500,
        },
      },
    ],
  });
  $('.nav-left-arrow').hide();
  $('.apl_lob_slider').on('afterChange', function (event, slick, currentSlide) {
    const $aplLobSlider = slick.$slider[0];
    setSlideVisibility($aplLobSlider);
    if (currentSlide === 0) {
      $('.nav-left-arrow').hide();
    } else {
      $('.nav-left-arrow').show();
    }
  });
  $('.apl_lob_list_item').on('click', function () {
    var prodList = '';
    var pageName = window.location.href;
    var arr;
    if (pageName.includes('collections')) {
      arr = pageName.split('/');
      prodList = arr[arr.length - 1] + '_plp_lob_stripe';
    } else {
      arr = pageName.split('/');
      prodList = arr[arr.length - 1] + '_pdp_lob_stripe';
    }
    localStorage.setItem('productList', prodList);
  });

  // Remove aria-describedby from slick slides
  $('.apl_lob_slider').each(function() {
    var app_lob_sliderId_1 = $(this);
    const slickSlides = $(app_lob_sliderId_1).find('.slick-list .slick-slide');
    if (slickSlides) {
      setTimeout(() => {
        adaFormatSlickSlides(slickSlides);
      }, 250);
    }
  });
});